import { parseISO, format, differenceInSeconds } from "date-fns";

/**
 * Converts an ISO timestamp into a readable date/time string in the user's local time.
 *
 * @param {string} isoString - The ISO-8601 timestamp.
 * @returns {string} Local date/time string, or "" if invalid.
 */
export function formatTimestamp(isoString) {
  if (!isoString) return "";

  try {
    const date = parseISO(isoString);
    return format(date, "M/d/yyyy, h:mm:ss a");
  } catch (error) {
    return "";
  }
}

export function convertUtcTimeToLocal(utcHour, utcMinute) {
  const utcTimestamp = `2000-01-01T${String(utcHour).padStart(2, "0")}:${String(utcMinute).padStart(2, "0")}:00Z`;
  const date = parseISO(utcTimestamp);
  const localHour = parseInt(format(date, "H"), 10);
  const localMinute = parseInt(format(date, "m"), 10);

  return { hour: localHour, minute: localMinute };
}

export function formatDuration(startTime, endTime) {
  if (!startTime || !endTime) return "";

  try {
    const start = parseISO(startTime);
    const end = parseISO(endTime);
    const totalSeconds = differenceInSeconds(end, start);

    if (totalSeconds < 0) return "";

    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const parts = [];
    if (days > 0) parts.push(`${days}d`);
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes}m`);
    if (seconds > 0 || parts.length === 0) parts.push(`${seconds}s`);

    return parts.join(" ");
  } catch (error) {
    return "";
  }
}
